<template>
  <div class="cosmetManager">
    <div class="main">
      <div class="left">
        <PatientsFormCosmetReg></PatientsFormCosmetReg>
      </div>
      <div class="right">
        <div class="rightRop">
          <ElectiveCosmetRegister></ElectiveCosmetRegister>
        </div>
        <div class="tightBottom">
          <ElectiveCosmetList></ElectiveCosmetList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PatientsFormCosmetReg from "./PatientsFormCosmetReg.vue";  
import ElectiveCosmetRegister from "./ElectiveCosmetRegister.vue";
import ElectiveCosmetList from "./ElectiveCosmetList.vue";
import popMixins from "../utils/popMixins.js";

export default {
  components: {
    PatientsFormCosmetReg,
    ElectiveCosmetRegister,
    ElectiveCosmetList
  },
  mixins:[popMixins],
  computed: {
    getcosmetRegistrationClear() {
      return this.$store.getters.getcosmetRegistrationClear; 
    },
    geteditCosmetRegistration() {
      return this.$store.state.editcosmetRegistration;
    }
  },
  beforeDestroy() {
    this.$store.commit("seteditcosmetRegistration", false);
  },
  watch: {
    // geteditOperation(newVal) {
    //   if (!newVal) {
    //     this.$store.commit("setoperationElectiveId", "");
    //     this.$store.commit("setoperationRelevantId", "");
    //     this.$store.commit("setoperationPatientId", "");
    //   }
    // },
    getcosmetRegistrationClear(newVal) {
      if (newVal) {
        this.$store.commit("setcosmetRegistrationClearClick", false);
        this.$store.commit("setcosmetRegistrationFormElectiveStatus", false);
        this.$store.commit("setcosmetRegistrationFormRelevantStatus", false);
        this.$store.commit("setcosmetRegistrationFormPatientStatus", false);
      }
    }
  }


};
</script>
<style lang="less" scoped>
.cosmetManager {
  width: 100%;
  height: 100%;
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    .left {
      width: 336px;
      height: 100%;
      background: #eff2f7;
    }
    .right {
      height: 100%;
      width: calc(~"100% - 336px");
      padding: 0 25px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .tightBottom {
        margin-top: 10px;
        height: calc(~"100% - 202px") !important;
      }
    }
  }
}
</style>
